module.exports = __webpack_public_path__ + "img/hiw_icon_No_Errors_Census.80d11a55.png";